export default {
  "months": {
    "long": [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ],
    "short": [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ]
  },
  "weekdays": {
    "long": [
      "Monday", "Tuesday", "Wednesday",
      "Thursday", "Friday", "Saturday", "Sunday"
    ],
    "short": [
      "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"
    ]
  },
  "buttons": {
    "today": "Today",
    "cancel": "Cancel",
    "select": "Select"
  }
};
